import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzFormModule } from 'ng-zorro-antd/form';

@Component({
  selector: 'lib-formly-checkbox',
  imports: [NzFormModule, ReactiveFormsModule, CommonModule, NzCheckboxModule],
  templateUrl: './formly-checkbox.component.html',
  styleUrl: './formly-checkbox.component.scss',
})
export class FormlyCheckboxComponent extends FieldType<FieldTypeConfig> {}
